import upbit from './upbit';
import cobit from './cobit';
import bithumb from './bithumb';

let a = {
  Upbit: upbit,
  Cobit: cobit,
  Bithumb: bithumb,
}

export default a;